<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
                >Search Form
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-form @submit.prevent="submit">
                  <v-row class="pa-2">
                   
                    <v-col lg="3" md="3" cols="12">
                      <v-autocomplete
                        label="Category"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="category.value.value"
                        :items="getCategoryList"
                        :item-title="(item) => `${item.name}`"
                        item-value="id"
                        :error-messages="category.errorMessage.value"
                        autocomplete="off"
                        hide-details
                        clearable
                      ></v-autocomplete>
                    </v-col>

                    <v-col lg="3" md="3" cols="12">
                      <v-autocomplete
                        label="Sub category"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="subcategory.value.value"
                        :items="getSubCategoryList"
                        :item-title="(item) => `${item.name}`"
                        item-value="id"
                        :error-messages="subcategory.errorMessage.value"
                        autocomplete="off"
                        hide-details
                        clearable
                      ></v-autocomplete>
                    </v-col>

                    <v-col lg="3" md="3" cols="12">
                      <v-autocomplete
                        label="Product type"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="product_type.value.value"
                        :items="getProductTypeList"
                        :item-title="(item) => `${item.name}`"
                        item-value="id"
                        :error-messages="product_type.errorMessage.value"
                        autocomplete="off"
                        hide-details
                        clearable
                      ></v-autocomplete>
                    </v-col>

                     <v-col lg="3" md="3" cols="12">
                      <v-autocomplete
                        label="Brand"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="brand.value.value"
                        :items="getBrandList"
                        :item-title="(item) => `${item.name}`"
                        item-value="id"
                        :error-messages="brand.errorMessage.value"
                        autocomplete="off"
                        hide-details
                        clearable
                      ></v-autocomplete>
                    </v-col>


                    <v-col lg="2" md="2" cols="12">
                      <v-btn
                        class="bg-brand w-15"
                        type="submit"
                        ref="searchButton"
                        >Search</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>

    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                Stock Reports
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-row class="py-2">
                  <v-col md="3" cols="12">
                    <v-text-field
                      v-model="search"
                      append-inner-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                      density="compact"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      class="pl-2"
                      clearable
                    ></v-text-field>
                  </v-col>

                  <v-col md="3" cols="12">
                    <div class="d-flex align-center flex-column">
                      <v-btn-group
                        variant="outlined"
                        density="compact"
                        size="x-small"
                        divided
                      >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="success"
                          @click="exportToCSV"
                          >CSV</v-btn
                        >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="primary"
                          @click="exportToExcel"
                          >EXCEL</v-btn
                        >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="red"
                          @click="exportToPDF"
                          >PDF</v-btn
                        >
                      </v-btn-group>
                    </div>
                  </v-col>

                  <v-col
                    md="3"
                    cols="12"
                    class="d-flex align-center flex-column"
                  >
                    <!-- <v-btn
                      prepend-icon="mdi mdi-upload"
                      variant="flat"
                      color="success"
                      @click="triggerCSVInput"
                    >
                      Import
                    </v-btn> -->
                  </v-col>

                  <v-col md="3" cols="12">
                    <!-- <div class="text-right pr-2">
                      <v-btn
                        v-if="$insertAccess($route.fullPath)"
                        @click="goTo('/inventory/add-product')"
                        color="primary"
                        variant="tonal"
                        prepend-icon="mdi mdi-plus"
                        rounded="xl"
                      >
                        Add Product
                      </v-btn>
                    </div> -->
                  </v-col>
                </v-row>
                <v-data-table
                  :headers="headers"
                  :items="reports"
                  :loading="loading"
                  v-model:items-per-page="itemsPerPage"
                  :search="search"
                  :hover="true"
                  density="compact"
                >
                  <template v-slot:item.index="{ index }">
                    {{ ++index }}
                  </template>

                </v-data-table>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>

  <input
    ref="csvInput"
    type="file"
    style="display: none"
    @change="handleCSVFile"
  />
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref } from "vue";
import { toast } from "vue3-toastify";
import Axios from "axios";
import { prefix } from "@/store/api";

export default {
  components: {},
  data: () => ({
    itemsPerPage: 10,
    panel: [0],
    search: "",
    dialog: false,
    data: {},
    headers: [
      { title: "#SL", align: "center", key: "index", sortable: false,},
      { title: "Warehouse", key: "warehouse_name", align: "left", sortable: false },
      { title: "Product Code", key: "product_code", align: "left", sortable: false },
      { title: "Product Name", key: "product_name", align: "left", sortable: false },
      { title: "Batch", key: "batch_no", align: "left", sortable: false },
      { title: "Unit Price", key: "purchase_unit_price", align: "left", sortable: false },
      { title: "Quantity", key: "quantity", align: "left", sortable: false },
      { title: "Valuation", key: "valuation", align: "left", sortable: false },     
    ],
  }),
  watch: {},
  created() {
    // Load dropdown data first
    const promises = [];

    if (this.$store.getters.getProductTypeList.length == 0) {
      promises.push(this.$store.dispatch("getProductTypeList"));
    }
    if (this.$store.getters.getCategoryList.length == 0) {
      promises.push(this.$store.dispatch("getCategoryList"));
    }
    if (this.$store.getters.getSubCategoryList.length == 0) {
      promises.push(this.$store.dispatch("getSubCategoryList"));
    }
    if (this.$store.getters.getBrandList.length == 0) {
      promises.push(this.$store.dispatch("getBrandList"));
    }

    // // Wait for dropdown data to load before initial product search
    // Promise.all(promises).then(() => {
    //   if (this.$store.getters.getSupplierMapList.length == 0) {
    //     // Trigger initial search after dropdown data is loaded
    //     this.$nextTick(() => {
    //       if (this.$refs.searchButton) {
    //         this.$refs.searchButton.$el.click();
    //       }
    //     });
    //   }
    // });
  },
  computed: {
    getSchema() {
      return this.$store.getters.getSupplierMapList;
    },
    getProductTypeList() {
      let data = this.$store.getters.getProductTypeList;
      if (data.length > 0) {
        return data.filter((item) => item.status == 1);
      }
      return [];
    },
    getCategoryList() {
      let data = this.$store.getters.getCategoryList;
      if (data.length > 0) {
        return data.filter((item) => item.status == 1);
      }
      return [];
    },
    
    getSubCategoryList() {
      let data = this.$store.getters.getSubCategoryList;
      if (data.length > 0) {
        return data.filter((item) => item.status == 1);
      }
      return [];
    },
    getBrandList() {
      let data = this.$store.getters.getBrandList;
      if (data.length > 0) {
        return data.filter((item) => item.status == 1);
      }
      return [];
    },
  },
  setup() {
    const { handleSubmit, resetForm } = useForm({
      validationSchema: yup.object({
        // Add validation if needed
        // product_type: yup.number().positive().integer().nullable().label('Product Type'),
        // category: yup.number().positive().integer().nullable().label('Category'),
        // subcategory: yup.number().positive().integer().nullable().label('Sub Category'),
      }),
    });

    const product_type = useField("product_type");
    const category = useField("category");
    const subcategory = useField("subcategory");
    const brand = useField("brand");
    const errorMessages = ref("");
    const loading = ref(false);
    const store = useStore();
    const reports = ref([]);

    const submit = handleSubmit((values) => {
      loading.value = true;

      Axios.get(`${prefix}inventory/stock-report`, { params: values })
        .then((response) => {
          reports.value = response.data.data;
          console.log(reports.value);
          loading.value = false;
        })
        .catch((error) => {
          loading.value = false;
          toast.error(error.response.data.message);
        });
    });

    return {
      product_type,
      category,
      subcategory,
      brand,
      submit,
      errorMessages,
      loading,
      reports,
    };
  },
  methods: {
    goTo(val) {
      this.$router.push({ path: val }).catch((err) => {});
    },
    editItem(item) {
      this.$store.commit("setEditingProduct", item);
      this.$router.push({ name: "add-product", query: {id: item.id} });
    },

    exportToPDF() {
      let serialNumber = 1;
      const columns = [
        "#SL",
        "Pro Code",
        "Code",
        "Name",
        "Brand",
        "Category",
        "Sub Category",
        "Type",
        "Size",
        "Unit",
        "Model",
        "Purchase Rate",
        "Sale Rate",
        "Tax",
        "Weight",
        "Status",
      ];
      const rows = this.getSchema.map((item) => [
        serialNumber++,
        item.product_code,
        item.code,
        item.name,
        item.brand.name,
        item.category?.name,
        item.subcategory?.name,
        item.type?.name,
        item.size?.name,
        item.unit?.name,
        item.model,
        item.purchase_rate,
        item.sale_rate,
        item.tax,
        item.weight,
        item.status == 1 ? "Active" : "Inactive",
      ]);
      this.$exportTableToPDF(
        columns,
        rows,
        "Product List",
        "product_list_" + this.$fileDate()
      );
    },
    exportToExcel() {
      var data = [
        [
          "#SL",
          "Pro Code",
          "Code",
          "Name",
          "Brand",
          "Category",
          "Sub Category",
          "Type",
          "Size",
          "Unit",
          "Model",
          "Purchase Rate",
          "Sale Rate",
          "Tax",
          "Weight",
          "Status",
        ],
      ];
      var serialNumber = 1;
      this.getSchema.forEach((item) => {
        data.push([
          serialNumber++,
          item.product_code,
          item.code,
          item.name,
          item.brand.name,
          item.category?.name,
          item.subcategory?.name,
          item.type?.name,
          item.size?.name,
          item.unit?.name,
          item.model,
          item.purchase_rate,
          item.sale_rate,
          item.tax,
          item.weight,
          item.status == 1 ? "Active" : "Inactive",
        ]);
      });
      this.$exportTableToExcel(data, "product_list_" + this.$fileDate());
    },
    exportToCSV() {
      var data = [
        [
          "#SL",
          "Pro Code",
          "Code",
          "Name",
          "Brand",
          "Category",
          "Sub Category",
          "Type",
          "Size",
          "Unit",
          "Model",
          "Purchase Rate",
          "Sale Rate",
          "Tax",
          "Weight",
          "Status",
        ],
      ];
      var serialNumber = 1;
      this.getSchema.forEach((item) => {
        data.push([
          serialNumber++,
          item.product_code,
          item.name,
          item.code,
          item.brand.name,
          item.category?.name,
          item.subcategory?.name,
          item.type?.name,
          item.size?.name,
          item.unit?.name,
          item.model,
          item.purchase_rate,
          item.sale_rate,
          item.tax,
          item.weight,
          item.status == 1 ? "Active" : "Inactive",
        ]);
      });

      this.$exportTableToCSV(data, "product_list_" + this.$fileDate());
    },

    triggerCSVInput() {
      this.$refs.csvInput.click();
    },

    handleCSVFile(event) {
      const file = event.target.files[0];
      // const allowedExtensions = [".csv"];
      // const fileExtension = file.name.slice(file.name.lastIndexOf(".")).toLowerCase();

      // if (!allowedExtensions.includes(fileExtension)) {
      //     toast.error("Please select a valid CSV file.");
      //     return;
      // }

      // Prepare FormData
      const formData = new FormData();
      formData.append("file", file);

      // Debug: Show FormData contents
      for (let pair of formData.entries()) {
        console.log(pair[0], pair[1]);
      }

      this.$store.dispatch("importProductCSV", formData)
        .then((response) => {
          toast.success("CSV imported successfully!");
          // Optionally refresh product list
          this.$refs.searchButton.$el.click();
        })
        .catch((error) => {
          toast.error(error.response?.data?.message || "Import failed.");
        });
    },
  },
  mounted() {
    // Auto-trigger search on mount like the requisition list
    this.$nextTick(() => {
      this.$refs.searchButton.$el.click();
    });   
  },
};
</script>
